module.exports = __webpack_public_path__ + "static/tom-brady-2d0a9ab3bf6f1afbd65a287f2ee6ecba.jpeg";